export default {
  en: { translation: require("./en.json") },
  ru: { translation: require("./ru.json") },
  uz: { translation: require("./uz.json") },
};
